export const getStorageValue = <T>(
  key: string,
  defaultValue: T,
  parse?: boolean
): T => {
  const saved = localStorage.getItem(key);
  try {
    const initial = parse ? JSON.parse(saved || '') : saved;
    return (initial || defaultValue) as T;
  } catch (e) {}

  return defaultValue;
};
